import compact from 'lodash/compact';

export const joinClasses = (classes) => compact(classes).join(' ');
